// TODO: consider moving this code to the shared module (because we'll need a similar
// feature on other landing pages in the future).
import {getActiveVariation} from "@plasmicapp/react-web/lib/splits";
import {splits} from "@/components/plasmic/nebank/PlasmicSplitsProvider";

function slugify(name: string): string {
    return name
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .replace(/[^a-zA-Z0-9]+/g, "-")
        .toLowerCase();
}

interface SliceContent {
    type: string;
    group?: string;
}

interface SplitSlice {
    id: string;
    contents: SliceContent[];
}

const themeSplits: {slices: SplitSlice[]}[] = splits;

export function resolveThemeSlug(
    traits?: Record<string, string | number | boolean>,
): string | undefined {
    const variation = getActiveVariation({splits, traits: traits ?? {}});
    const activeSliceIds = new Set(Object.values(variation));

    const themeGroup = themeSplits
        .flatMap((split) => split.slices)
        .filter((slice) => activeSliceIds.has(slice.id))
        .flatMap((slice) => slice.contents)
        .find(
            (content) => content.type === "global-variant" && content.group?.startsWith("Theme"),
        )?.group;

    return themeGroup ? slugify(themeGroup) : undefined;
}

export function faviconLinks(slug: string | undefined) {
    const suffix = slug ? `_${slug}` : "";

    return (
        <>
            <meta property="og:image" content={`/favicon-512x512${suffix}.png`} />
            <link rel="icon" type="image/png" sizes="16x16" href={`/favicon-16x16${suffix}.png`} />
            <link rel="icon" type="image/png" sizes="32x32" href={`/favicon-32x32${suffix}.png`} />
            <link rel="apple-touch-icon" href={`/apple-touch-icon${suffix}.png`} />
            <link rel="icon" href={`/favicon${suffix}.ico`} sizes="32x32" />
        </>
    );
}
